/**
 * Module tra cứu truyện và video (Modal Tìm kiếm Workspace)
 * HOÀN TOÀN KHÔNG HIỂN THỊ THÔNG TIN NGUỒN HOẶC TÊN WEBSITE THỰC TẾ Ở FRONTEND
 * Hỗ trợ chuyển đổi linh hoạt giữa các Kho Dữ liệu (Kho 1, Kho 2, Tất cả nguồn)
 */
import { ApiClient } from '../services/apiClient.js';
import { UrlService } from '../services/urlService.js';
import { InvidiousService } from '../services/invidiousService.js';
import { ShortsService } from '../services/shortsService.js';
import { DEFAULT_SOURCE, ADAPTER_SOURCES } from '../config/constants.js';

export class SearchModalModule {
  constructor(storyReader) {
    this.storyReader = storyReader;
    this.currentStoryId = '';
    // Mặc định loại tìm kiếm là Truyện
    this.searchType = 'story';
    this.searchRequestId = 0;
    this.onSelectVideo = null;
    // Mặc định tìm kiếm gộp từ tất cả các nguồn để kết quả phong phú nhất
    this.currentSource = ADAPTER_SOURCES.ALL || 'all';

    // Header Quick Search Button (Nút icon kính lúp trên header)
    this.quickSearchBtn = document.getElementById('quick-search-btn');

    // Modal Elements (Popup tìm kiếm ngụy trang VLOOKUP Assistant)
    this.modal = document.getElementById('search-modal');
    this.btnClose = document.getElementById('modal-close-btn');
    this.inputSearch = document.getElementById('modal-search-input');
    this.btnSearch = document.getElementById('modal-search-btn');
    this.statusEl = document.getElementById('modal-status');
    this.titleEl = document.getElementById('search-modal-title');
    this.resultsContainer = document.getElementById('search-results-container');
    this.storyListEl = document.getElementById('story-list');
    this.chaptersContainer = document.getElementById('chapters-container');
    this.chapterListEl = document.getElementById('chapter-list');
    this.btnBackToStories = document.getElementById('btn-back-to-stories');
    this.selectedStoryTitleEl = document.getElementById('selected-story-title');
    this.descriptionEl = document.getElementById('search-modal-description');
    this.videoResultsContainer = document.getElementById('video-results-container');
    this.videoListEl = document.getElementById('video-result-list');
    this.searchTypeTabs = document.querySelectorAll('.ws-search-type-tab');

    // Tabs chọn nguồn ngụy trang (Kho 1, Kho 2, Tất cả)
    this.sourceTabs = document.querySelectorAll('.source-tab');

    this.bindEvents();
  }

  bindEvents() {
    // 1. Bấm vào icon Tìm kiếm trên Header để mở Modal
    if (this.quickSearchBtn) {
      this.quickSearchBtn.addEventListener('click', () => {
        this.open();
      });
    }

    this.searchTypeTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        this.setSearchType(tab.getAttribute('data-search-type'));
        this.inputSearch?.focus();
      });
    });

    // 2. Chuyển đổi tab chọn nguồn ngụy trang
    if (this.sourceTabs && this.sourceTabs.length > 0) {
      this.sourceTabs.forEach(tab => {
        tab.addEventListener('click', () => {
          this.sourceTabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');
          this.currentSource = tab.getAttribute('data-source') || 'all';

          // Nếu ô tìm kiếm đã có từ khóa, tự động truy vấn lại với nguồn mới
          const keyword = (this.inputSearch.value || '').trim();
          if (keyword) {
            this.handleSearch(keyword, this.currentSource, true);
          }
        });
      });
    }

    // 3. Tìm kiếm bên trong Modal
    this.btnClose.addEventListener('click', () => this.close());
    this.modal.addEventListener('click', (event) => {
      if (event.target === this.modal) this.close();
    });
    this.btnSearch.addEventListener('click', () => this.handleSearch(this.inputSearch.value, this.currentSource, true));
    this.inputSearch.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') this.handleSearch(this.inputSearch.value, this.currentSource, true);
    });

    this.btnBackToStories.addEventListener('click', () => {
      this.chaptersContainer.style.display = 'none';
      this.resultsContainer.style.display = 'block';
    });

    // 4. Phím tắt mở nhanh Modal: Ctrl + K, Ctrl + F hoặc Alt + /
    window.addEventListener('keydown', (e) => {
      const isCtrlK = (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k';
      const isCtrlF = (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'f';
      const isAltSlash = e.altKey && e.key === '/';

      if (isCtrlK || isCtrlF || isAltSlash) {
        e.preventDefault();
        this.open();
      } else if (e.key === 'Escape' && this.modal.style.display === 'flex') {
        this.close();
      }
    });
  }

  /**
   * Mở Modal tìm kiếm và focus vào ô nhập từ khóa
   * Mặc định kích hoạt tab Truyện theo yêu cầu
   * @param {string} [keyword=''] Từ khóa tìm kiếm ban đầu
   * @param {'story'|'video'} [searchType='story'] Loại tìm kiếm mặc định
   */
  open(keyword = '', searchType = 'story') {
    if (!this.modal || !this.inputSearch) return;
    this.modal.style.display = 'flex';
    this.modal.setAttribute('aria-hidden', 'false');
    this.inputSearch.value = keyword;
    // Kích hoạt tab được chỉ định (mặc định là 'story')
    this.setSearchType(searchType, false);
    this.inputSearch.focus();
    this.inputSearch.select();
  }

  setVideoSelectHandler(handler) {
    this.onSelectVideo = typeof handler === 'function' ? handler : null;
  }

  setSearchType(type, searchIfReady = true) {
    if (type === 'shorts') {
      this.searchType = 'shorts';
    } else if (type === 'video') {
      this.searchType = 'video';
    } else {
      this.searchType = 'story';
    }
    this.searchRequestId += 1;
    if (this.titleEl) {
      if (this.searchType === 'shorts') {
        this.titleEl.textContent = 'Tìm video ngắn (Shorts)';
      } else if (this.searchType === 'video') {
        this.titleEl.textContent = 'Tìm video YouTube';
      } else {
        this.titleEl.textContent = 'Tìm truyện';
      }
    }
    this.searchTypeTabs.forEach(tab => {
      const isActive = tab.getAttribute('data-search-type') === this.searchType;
      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-pressed', String(isActive));
    });
    if (this.descriptionEl) {
      if (this.searchType === 'shorts') {
        this.descriptionEl.textContent = 'Tìm video ngắn tỷ lệ 9:16 và vuốt xem tiếp liên tục.';
      } else if (this.searchType === 'video') {
        this.descriptionEl.textContent = 'Tìm video YouTube và bấm vào kết quả để phát ngay.';
      } else {
        this.descriptionEl.textContent = 'Tìm truyện trong các nguồn dữ liệu, sau đó chọn chương để đọc.';
      }
    }
    if (this.inputSearch) {
      if (this.searchType === 'shorts') {
        this.inputSearch.placeholder = 'Nhập chủ đề video ngắn (vd: hài hước, giải trí)...';
        this.inputSearch.setAttribute('aria-label', 'Chủ đề video ngắn cần tìm');
      } else if (this.searchType === 'video') {
        this.inputSearch.placeholder = 'Nhập tên video hoặc dán link YouTube...';
        this.inputSearch.setAttribute('aria-label', 'Tên video cần tìm');
      } else {
        this.inputSearch.placeholder = 'Nhập tên truyện...';
        this.inputSearch.setAttribute('aria-label', 'Tên truyện cần tìm');
      }
    }
    if (this.sourceTabs.length) {
      const sourceFilter = document.getElementById('source-filter-group');
      if (sourceFilter) sourceFilter.style.display = this.searchType === 'story' ? '' : 'none';
    }
    if (this.resultsContainer) this.resultsContainer.style.display = 'none';
    if (this.chaptersContainer) this.chaptersContainer.style.display = 'none';
    if (this.videoResultsContainer) this.videoResultsContainer.style.display = 'none';

    const keyword = (this.inputSearch?.value || '').trim();
    if (searchIfReady && keyword) {
      this.handleSearch(keyword, this.currentSource, true);
    } else if (this.statusEl) {
      this.statusEl.textContent = '';
    }
  }

  /**
   * Đóng Modal tìm kiếm
   */
  close() {
    if (!this.modal) return;
    this.modal.style.display = 'none';
    this.modal.setAttribute('aria-hidden', 'true');
    UrlService.clearSearch();
  }

  /**
   * Kích hoạt tìm kiếm từ URL params hoặc từ bên ngoài
   * @param {string} keyword 
   * @param {string} source 
   * @param {boolean} updateUrl 
   */
  triggerSearch(keyword, source = 'all', updateUrl = true) {
    const q = (keyword || '').trim();
    if (!q) {
      this.open();
      return;
    }
    this.open();
    this.inputSearch.value = q;
    this.setSearchType('story', false);

    // Cập nhật tab active tương ứng với source
    this.currentSource = source || 'all';
    this.sourceTabs.forEach(t => {
      if (t.getAttribute('data-source') === this.currentSource) {
        t.classList.add('active');
      } else {
        t.classList.remove('active');
      }
    });

    this.handleSearch(q, this.currentSource, updateUrl);
  }

  /**
   * Thực hiện gọi API tìm kiếm truyện từ Backend
   * @param {string} keyword 
   * @param {string} source 
   * @param {boolean} updateUrl 
   */
  async handleSearch(keyword, source = 'all', updateUrl = true) {
    const q = (keyword || '').trim();
    if (!q) return;
    const requestId = ++this.searchRequestId;

    if (this.searchType === 'shorts') {
      await this.handleShortsSearch(q, requestId);
      return;
    }

    if (this.searchType === 'video') {
      await this.handleVideoSearch(q, requestId);
      return;
    }

    this.currentSource = source || 'all';

    if (updateUrl) {
      UrlService.setSearch(q, this.currentSource, true);
    }

    this.statusEl.textContent = 'Đang truy vấn dữ liệu từ các kho lưu trữ...';
    this.resultsContainer.style.display = 'none';
    this.chaptersContainer.style.display = 'none';
    this.storyListEl.innerHTML = '';

    try {
      const res = await ApiClient.searchStories(q, this.currentSource);
      if (requestId !== this.searchRequestId) return;
      if (res.success && res.data && res.data.length > 0) {
        this.statusEl.textContent = `Tìm thấy ${res.data.length} bản ghi khớp với "${q}":`;
        this.renderStoryList(res.data);
      } else {
        this.statusEl.textContent = `Không tìm thấy truyện nào khớp với từ khóa "${q}".`;
      }
    } catch (err) {
      if (requestId !== this.searchRequestId) return;
      this.statusEl.textContent = 'Lỗi tìm kiếm: ' + err.message;
    }
  }

  async handleVideoSearch(keyword, requestId = this.searchRequestId) {
    const query = (keyword || '').trim();
    if (!query) return;
    this.resultsContainer.style.display = 'none';
    this.chaptersContainer.style.display = 'none';
    this.videoResultsContainer.style.display = 'none';
    this.videoListEl.replaceChildren();

    const directVideoId = InvidiousService.extractVideoId(query);
    if (directVideoId) {
      this.selectVideo({ videoId: directVideoId, title: `YouTube video ${directVideoId}` });
      return;
    }

    this.statusEl.textContent = `Đang tìm video YouTube khớp với "${query}"...`;
    try {
      const videos = await InvidiousService.searchVideos(query, 20);
      if (requestId !== this.searchRequestId) return;
      if (!videos.length) {
        this.statusEl.textContent = `Không tìm thấy video nào khớp với "${query}".`;
        return;
      }
      this.statusEl.textContent = `Tìm thấy ${videos.length} video. Bấm vào video để phát ngay:`;
      this.renderVideoList(videos);
    } catch (err) {
      if (requestId !== this.searchRequestId) return;
      this.statusEl.textContent = `Lỗi tìm kiếm video: ${err.message}`;
    }
  }

  renderVideoList(videos) {
    this.videoListEl.replaceChildren();
    this.videoResultsContainer.style.display = 'block';
    videos.forEach(video => {
      const item = document.createElement('button');
      item.className = 'ws-video-result';
      item.type = 'button';
      item.setAttribute('aria-label', `Phát ${video.title}`);

      const thumbnail = document.createElement('img');
      thumbnail.className = 'ws-video-result-thumb';
      thumbnail.src = video.thumbnail;
      thumbnail.alt = '';
      thumbnail.loading = 'lazy';

      const info = document.createElement('span');
      info.className = 'ws-video-result-info';
      const title = document.createElement('span');
      title.className = 'ws-video-result-title';
      title.textContent = video.title;
      const meta = document.createElement('span');
      meta.className = 'ws-video-result-meta';
      meta.textContent = [video.author, video.durationText].filter(Boolean).join(' · ');
      info.append(title, meta);
      item.append(thumbnail, info);
      item.addEventListener('click', () => this.selectVideo(video));
      this.videoListEl.appendChild(item);
    });
  }

  selectVideo(video) {
    if (!video?.videoId) return;
    if (!this.onSelectVideo) {
      this.statusEl.textContent = 'Không thể mở video: chưa kết nối bộ điều hướng.';
      return;
    }
    this.close();
    this.onSelectVideo(video.videoId, video.title || '');
  }

  /**
   * Xử lý tìm kiếm video ngắn Shorts
   * @param {string} keyword Từ khóa tìm kiếm
   * @param {number} requestId Mã định danh request để chống race condition
   */
  async handleShortsSearch(keyword, requestId = this.searchRequestId) {
    const query = (keyword || '').trim();
    if (!query) return;

    this.resultsContainer.style.display = 'none';
    this.chaptersContainer.style.display = 'none';
    this.videoResultsContainer.style.display = 'none';
    this.videoListEl.replaceChildren();

    // Nếu người dùng dán trực tiếp ID hoặc link shorts
    const directShortId = ShortsService.extractShortId(query);
    if (directShortId) {
      this.selectShort({ videoId: directShortId, title: `Shorts video ${directShortId}` });
      return;
    }

    this.statusEl.textContent = `Đang tìm kiếm video ngắn khớp với "${query}"...`;
    try {
      const shorts = await ShortsService.getShortsFeed(query, 1);
      if (requestId !== this.searchRequestId) return;

      if (!shorts || !shorts.length) {
        this.statusEl.textContent = `Không tìm thấy video ngắn nào khớp với "${query}".`;
        return;
      }

      this.statusEl.textContent = `Tìm thấy ${shorts.length} video ngắn. Bấm để phát và vuốt xem tiếp:`;
      this.renderShortsList(shorts);
    } catch (err) {
      if (requestId !== this.searchRequestId) return;
      this.statusEl.textContent = `Lỗi tìm kiếm Shorts: ${err.message}`;
    }
  }

  /**
   * Hiển thị danh sách kết quả video Shorts
   * @param {Array} shorts Danh sách video ngắn
   */
  renderShortsList(shorts) {
    this.videoListEl.replaceChildren();
    this.videoResultsContainer.style.display = 'block';

    shorts.forEach(short => {
      const item = document.createElement('button');
      item.className = 'ws-video-result';
      item.type = 'button';
      item.setAttribute('aria-label', `Xem Shorts ${short.title}`);

      const thumbnail = document.createElement('img');
      thumbnail.className = 'ws-video-result-thumb';
      thumbnail.src = short.thumbnail;
      thumbnail.alt = '';
      thumbnail.loading = 'lazy';
      // Style tỷ lệ dọc 9:16 nhỏ cho thumbnail shorts
      thumbnail.style.aspectRatio = '9/16';
      thumbnail.style.objectFit = 'cover';
      thumbnail.style.width = '48px';
      thumbnail.style.height = '85px';

      const info = document.createElement('span');
      info.className = 'ws-video-result-info';
      const title = document.createElement('span');
      title.className = 'ws-video-result-title';
      title.textContent = short.title;
      const meta = document.createElement('span');
      meta.className = 'ws-video-result-meta';
      meta.textContent = ['⚡ Shorts', short.viewCountText].filter(Boolean).join(' · ');
      info.append(title, meta);
      item.append(thumbnail, info);
      item.addEventListener('click', () => this.selectShort(short));
      this.videoListEl.appendChild(item);
    });
  }

  /**
   * Mở video Shorts được chọn bằng ShortsViewer
   * @param {Object} short Thông tin video ngắn
   */
  selectShort(short) {
    if (!short?.videoId) return;
    this.close();

    // Xác định route mở Shorts: Nếu đang ở emulator thì giữ emulator, mặc định mở Figma Prototype
    const currentHash = (window.location.hash || '').toLowerCase();
    const targetRoute = currentHash.startsWith('#/emulator') ? '#/emulator' : '#/figma';

    if (window.appRouter && typeof window.appRouter.navigateTo === 'function') {
      window.appRouter.navigateTo(`${targetRoute}?v=${encodeURIComponent(short.videoId)}`);
    } else if (targetRoute === '#/figma' && window.figmaController) {
      window.figmaController.activate(short.videoId);
    } else if (window.emulatorController) {
      window.emulatorController.activate(short.videoId);
    } else if (this.onSelectVideo) {
      this.onSelectVideo(short.videoId, short.title || '');
    }
  }

  /**
   * Hiển thị danh sách kết quả truyện tìm được
   * @param {Array} stories 
   */
  renderStoryList(stories) {
    this.storyListEl.innerHTML = '';
    this.resultsContainer.style.display = 'block';

    stories.forEach(story => {
      const item = document.createElement('div');
      item.className = 'story-item';

      // Nhãn nguồn ngụy trang (Kho 1, Kho 2)
      const sourceBadge = story.source === 's2'
        ? '<span class="story-tag tag-s2">Kho 2</span>'
        : '<span class="story-tag tag-s1">Kho 1</span>';

      const tagsHtml = `
        ${sourceBadge}
        ${story.is_full ? '<span class="story-tag tag-full">Full</span>' : ''}
        ${story.is_hot ? '<span class="story-tag tag-hot">Hot</span>' : ''}
      `;

      // TUYỆT ĐỐI KHÔNG HIỂN THỊ NGUỒN NGOÀI Ở ĐÂY, CHỈ HIỆN TÊN TRUYỆN, TÁC GIẢ VÀ CHƯƠNG MỚI
      item.innerHTML = `
        <div>
          <div class="story-name">${story.title} ${tagsHtml}</div>
          <div class="story-meta">Tác giả: ${story.author || 'Nhiều tác giả'} | ${story.latest_chapter || 'Đang cập nhật'}</div>
        </div>
        <button class="modal-btn primary-btn">Xem danh sách chương →</button>
      `;

      item.addEventListener('click', () => {
        // Tự động truyền đúng source của truyện ('s1' hoặc 's2')
        this.loadChapters(story.source || DEFAULT_SOURCE, story.story_id, story.title);
      });

      this.storyListEl.appendChild(item);
    });
  }

  /**
   * Tải toàn bộ danh sách chương của truyện từ đúng nguồn
   * @param {string} source 
   * @param {string} storyId 
   * @param {string} storyTitle 
   */
  async loadChapters(source, storyId, storyTitle) {
    this.currentSource = source || DEFAULT_SOURCE;
    this.currentStoryId = storyId;
    this.statusEl.textContent = `Đang lấy danh sách chương của "${storyTitle}"...`;
    this.resultsContainer.style.display = 'none';
    this.chaptersContainer.style.display = 'none';

    try {
      const res = await ApiClient.getStoryDetail(storyId, this.currentSource);
      if (res.success && res.data) {
        this.statusEl.textContent = '';
        this.selectedStoryTitleEl.textContent = res.data.title;
        this.storyReader.setStoryChapters(this.currentSource, storyId, res.data.chapters);
        this.renderChapterList(res.data.chapters);
      } else {
        this.statusEl.textContent = 'Không thể lấy danh sách chương: ' + (res.message || 'Lỗi không xác định');
      }
    } catch (err) {
      this.statusEl.textContent = 'Lỗi: ' + err.message;
    }
  }

  /**
   * Hiển thị danh sách các chương để người dùng chọn đọc
   * @param {Array} chapters 
   */
  renderChapterList(chapters) {
    this.chapterListEl.innerHTML = '';
    this.chaptersContainer.style.display = 'block';

    if (!chapters || chapters.length === 0) {
      this.chapterListEl.innerHTML = '<div style="padding:10px;">Không có chương nào.</div>';
      return;
    }

    chapters.forEach(c => {
      const item = document.createElement('div');
      item.className = 'chapter-item';
      item.textContent = c.title;
      item.title = c.title;

      item.addEventListener('click', () => {
        this.close();
        this.storyReader.openedTabs = [];
        // Nạp chương từ đúng nguồn đã chọn
        this.storyReader.loadChapter(this.currentSource, this.currentStoryId, c.chapter_id, true);
      });

      this.chapterListEl.appendChild(item);
    });
  }
}
